"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const classnames_template_literals_1 = __importDefault(require("@netlify/classnames-template-literals"));
const LoadingComponent_1 = __importDefault(require("components/shared/LoadingComponent"));
const Button = ({ id, variant = 'primary', children, style, disabled = false, isLoading = false, onClick, customClass, datacy, onMouseEnter, onMouseLeave, stopPropagation = true, key, alignText = 'center', usePadding = true, onMouseDown }) => {
    const isDisabled = disabled || isLoading;
    const getVariantClassName = () => {
        return (0, classnames_template_literals_1.default)(`
      cursor-pointer

      ${variant === 'primary' &&
            `
          ${usePadding && 'px-[16px]'}
          border-0
          bg-base-600
          text-n-100
          hover:bg-base-500 active:bg-base-500
        `}

      ${variant === 'secondary' &&
            alignText !== 'left' &&
            `
          ${usePadding && 'px-[16px]'}
          border
          border-solid
          border-n-400 bg-n-000 text-n-900
        `}

      ${variant === 'secondary' &&
            alignText === 'left' &&
            `
          border-0
          bg-transparent
        `}

      ${variant === 'tertiary' &&
            !isDisabled &&
            `
          border-0
          bg-transparent
          text-base-600
          ${usePadding && 'px-[8px]'}
        `}

      ${variant === 'danger' &&
            !isDisabled &&
            `
          border-0
          bg-r-600
          px-[16px]
          text-n-100
        `}
      ${(variant === 'secondary' || variant == 'tertiary') &&
            !isDisabled &&
            `hover:bg-base-30024 active:bg-base-30024`}
    `);
    };
    const btnCN = (0, classnames_template_literals_1.default)(`
    flex

    ${alignText === 'left' && `justify-start`}
    ${alignText === 'right' && `justify-end`}
    ${alignText === 'center' && `justify-center`}

    min-h-[32px]
    items-center
    whitespace-nowrap
    rounded-[4px]
    leading-[16px]

    ${!isDisabled
        ? getVariantClassName()
        : 'disabled cursor-not-allowed border-0 bg-n-300 px-[16px] text-n-600'}

    ${customClass}
  `);
    let onEnterProps = {};
    if (onMouseEnter && onMouseLeave) {
        onEnterProps = {
            onMouseEnter,
            onMouseLeave
        };
    }
    return (react_1.default.createElement("button", { id: id, key: key || id, className: btnCN, style: { ...style, outline: 'none' }, onClick: (e) => {
            stopPropagation && e.stopPropagation();
            onClick && onClick(e);
        }, onMouseDown: (e) => {
            e.stopPropagation();
            onMouseDown && onMouseDown();
        }, disabled: isDisabled, "data-cy": datacy, ...onEnterProps },
        isLoading && (react_1.default.createElement(LoadingComponent_1.default, { hasText: false, size: 20, className: "py-[0px] mr-[4px]" })),
        children));
};
const Secondary = (props) => {
    return react_1.default.createElement(Button, { variant: "secondary", ...props });
};
const Tertiary = (props) => {
    return react_1.default.createElement(Button, { variant: "tertiary", ...props });
};
Button.Secondary = Secondary;
Button.Tertiary = Tertiary;
exports.default = Button;
